import styled, { css } from "styled-components";
import { textOverflowEllipsisMixin } from "@evergis/ui";

export const nonEditableFieldMixin = css`
  font-size: 0.75rem;
  opacity: 0.54;
  color: ${({ theme: { palette } }) => palette.textPrimary};
`;

const uniqueFieldMixin = css`
  opacity: 0.87;
  font-size: 1rem;
`;

export const NonEditableField = styled.span<{ uniqueField?: boolean; maxWidth?: string }>`
  ${textOverflowEllipsisMixin};
  ${nonEditableFieldMixin};
  max-width: ${({ maxWidth }) => maxWidth};
  text-overflow: ellipsis;

  :focus {
    outline: none;
  }

  ${({ uniqueField }) => uniqueField && uniqueFieldMixin};
`;

export const NonEditableNumber = styled(NonEditableField)``;
